import { ILiverampDistributionListInfo } from '~/src/dash/api/liveramp-distribution/liveramp_distribution_model';
import { parseArray, transformModel } from '~/src/dash/api/resource-transforms';
import { createUrl, restGet, restPost } from '~/src/dash/api/rest';
import { onlyNumeric } from '~/src/dash/globals/constants';

interface IHeaderBidderQueries {
  [key: string]: any;
}

export const transformReqBody = transformModel<any>({
  selectedChannelIds: parseArray(['selectedChannelIds'], (obj: any) => {
    return obj;
  }),
  preloads: parseArray(['preloads'], (obj: any) => {
    return obj;
  }),
  uiFields: parseArray(['uiFields'], (obj: any) => {
    return obj;
  }),
});

export interface ILiverampDistributionParams {
  urlQueries: IHeaderBidderQueries;
}

export interface ILiverampDistributionListInfoWithCount {
  requested_segments: ILiverampDistributionListInfo[];
  total_count: number;
  success: boolean;
  status: string;
  pagination_token: string;
}

export interface DistributionSuccess {
  success: boolean;
}

export async function getLiverampSegmentsFromDistributionManagerWithPagination(
  publisherID: string,
  { urlQueries = {} }: ILiverampDistributionParams,
): Promise<[ILiverampDistributionListInfoWithCount | undefined, string | undefined]> {
  let reqUrl = createUrl('/get_liveramp_segments_from_distribution_manager', publisherID, 'v1');
  reqUrl = addUrlQueries(urlQueries, reqUrl);
  try {
    return [
      (await restGet<ILiverampDistributionListInfoWithCount>(reqUrl, transformReqBody({})))
        .parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

// Transforms passed in queries and appends them to requestURL
function addUrlQueries(urlQueries: IHeaderBidderQueries, reqUrl: string): string {
  for (const [key, value] of Object.entries(urlQueries)) {
    switch (key) {
      case 'page':
        reqUrl += '&page=' + String(value);
        break;
      case 'pageSize':
        reqUrl += '&page_size=' + String(value);
        break;
      case 'search':
        reqUrl += '&search=' + String(value);
        break;
      case 'paginationToken':
        reqUrl += '&pagination_token=' + String(value);
        break;
      case 'status':
        reqUrl += '&status=' + String(value);
        break;
      case 'segmentIDs':
        reqUrl += '&segment_ids=' + String(value);
        break;
      case 'orderBy':
        reqUrl += '&order_by=' + String(value);
        break;
      case 'orderDirection':
        reqUrl += '&order_direction=' + String(value);
        break;
    }
  }
  return reqUrl;
}

// determines if the search string only contains numbers and if so, returns a string with those numbers
export const createIDSearch = (search: string): string => {
  search = search.trim();
  if (onlyNumeric(search)) {
    return search;
  }
  return '';
};

// distribute segments
export const distributeSegments = async (
  publisherID: string,
  { urlQueries = {} }: IHeaderBidderQueries,
): Promise<DistributionSuccess | undefined> => {
  let reqUrl = createUrl('/distribute_liveramp_segments', publisherID, 'v1');
  reqUrl = addUrlQueries(urlQueries, reqUrl);
  try {
    const res = await restPost<DistributionSuccess>(reqUrl, transformReqBody({}));
    return res.parsedBody;
  } catch (e) {
    return {
      success: false,
    };
  }
};
